'use client';

import { logger } from '@lichtblick/logger';
import type { PageMetaClassification } from '@lichtblick/tracker';
import dynamic from 'next/dynamic';
import { Component, type ErrorInfo, type FC, type PropsWithChildren } from 'react';
import { CONNECTION_ERROR_MESSAGE } from './b2b-funnel-embed.content';
import { PageMetaProvider } from './b2b-funnel-embed.tracking';
import type { B2BFunnelState } from './update-state.types';

const InnerFunnelEmbed = dynamic(() =>
  import('./b2b-funnel-embed.inner').then(({ InnerFunnelEmbed }) => InnerFunnelEmbed),
);

class ErrorSafeFunnelEmbed extends Component<any, { hasError: boolean }> {
  private latestState?: B2BFunnelState;
  constructor(props: PropsWithChildren) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(_error: any) {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    logger.error('EMBEDDED_SOLAR_FUNNEL: FunnelEmbed crashed - fallback is rendered', errorInfo, error);
  }

  private readonly syncLatestState = (state: B2BFunnelState) => {
    this.latestState = state;
  };
  render() {
    const initialState =
      this.state.hasError && this.latestState
        ? { ...this.latestState, errors: { generic: CONNECTION_ERROR_MESSAGE, ...this.latestState?.errors } }
        : undefined;

    return <InnerFunnelEmbed initialState={initialState} onStateChange={this.syncLatestState} />;
  }
}

export interface FunnelEmbedProps {
  pageMetaClassification?: PageMetaClassification;
}
export const B2BFunnelEmbed: FC<FunnelEmbedProps> = ({
  pageMetaClassification = { pageArea: 'B2B', pageType: 'product' },
}) => (
  <PageMetaProvider value={pageMetaClassification}>
    <ErrorSafeFunnelEmbed />
  </PageMetaProvider>
);
